import classNames from "classnames";

export interface LoadingProps {
  isActive: boolean;
  titleText?: string;
  bodyText?: string;
  className?: string;
  bodyClassName?: string;
}

export const Loading = ({
  isActive,
  titleText = "Loading admin application",
  bodyText = "please wait...",
  className,
  bodyClassName,
}: LoadingProps): JSX.Element => {
  const generatedClasses = {
    wrapper: classNames(className, "u-flex u-items-center u-justify-center", {
      ["u-hidden"]: !isActive,
    }),
    body: classNames(
      "c-loading u-flex u-items-center u-justify-center u-flex-col u-font-bold",
      bodyClassName
    ),
  };

  return (
    <div className={generatedClasses.wrapper}>
      <div className={generatedClasses.body}>
        <p className="u-text-2xl">{titleText}</p>
        <div className="c-spinner u-my-8 u-mx-auto">
          <div className="c-spinner_segment"></div>
          <div className="c-spinner_circle"></div>
        </div>
        <p>{bodyText}</p>
      </div>
    </div>
  );
};
